import * as React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import UsersRegular from './users-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <UsersRegular {...validProps} />;
}
SvgComponent.iconName = 'usersRegular';

export const UsersRegularIcon = svgIconWrapper(SvgComponent);
